import React from "react"
import { Flex, Text } from "@chakra-ui/react"
import Icon from "./Icon"

type Props = {
  label: string
  value: string | number
  danger?: boolean
  isClickable?: boolean
  valueFontSize?: string
  labelFontSize?: string
  /** When false, show label first then value (e.g. webpage builder). Default true = value first. */
  valueFirst?: boolean
}

const HorizontalStat = ({
  label, value, danger, isClickable, valueFontSize, labelFontSize, valueFirst = true,
}: Props) => {
  const prominentFontSize = valueFirst ? (valueFontSize || "2xl") : (labelFontSize || "2xl")
  const secondaryFontSize = valueFirst ? labelFontSize : valueFontSize

  return (
    <Flex align="center" {...danger && { color: "red.500" }}>
      {valueFirst ? (
        <>
          <Text as="span" fontWeight="semibold" fontSize={prominentFontSize} mr={2}>{value}</Text>
          <Text as="span" {...(secondaryFontSize && { fontSize: secondaryFontSize })}>{label}</Text>
        </>
      ) : (
        <>
          <Text as="span" fontWeight="bold" fontSize={prominentFontSize} mr={2}>{label}</Text>
          <Text as="span" {...(secondaryFontSize && { fontSize: secondaryFontSize })}>{value}</Text>
        </>
      )}
      {isClickable && <Icon icon="growl-info" color="gray.400" size={3.5} ml={1.5} />}
    </Flex>
  )
}

export default HorizontalStat
